import { api } from "./api";
import type { Farm } from "@/types/models";

export const farmService = {
  get: (): Promise<Farm> => api.get("/farm").then((r) => r.data),
  update: (data: Partial<Farm>): Promise<Farm> => api.put("/farm", data).then((r) => r.data),
};
